import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../helpers/Routes";

const Button = ({
  name,
  route,
  isDisabled,
  onClickFn,
  onContinueClick_Apply,
  onContinueClick_ConnectBank,
  onContinueClick_Login,
  onContinueClick_Otp,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  // const onContinueClick_Routing = (e) => {
  // if (location.pathname === routes.apply) {
  //   navigate(routes.connectBank);
  // }
  // if (location.pathname === routes.connectBank) {
  //   navigate(routes.login);
  // }
  // if (location.pathname === routes.login) {
  //   navigate(routes.otp);
  // }
  // if (location.pathname === routes.apply) {
  //   navigate(routes.connectBank);
  // }
  // };

  return (
    <div
      // type="submit"
      onClick={
        location.pathname === routes.otp
          ? onContinueClick_Otp
          : location.pathname === routes.apply
          ? onContinueClick_Apply
          : location.pathname === routes.connectBank
          ? onContinueClick_ConnectBank
          : location.pathname === routes.login
          ? onContinueClick_Login
          : null
      }
      className={`${isDisabled ? `buttonTag` : `buttonTagDisabled`} outline-none text-center`}
      // style={{pointerEvents:"none"}}
    >
      {name}
    </div>
  );
};

export default Button;
